
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-relations/investor-day-registration",
      function () {
        return require("private-next-pages/investor-relations/investor-day-registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-relations/investor-day-registration"])
      });
    }
  